var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodeError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L14 14",
    stroke: "#E00000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.33333C11.6667 2.66667 10 2 8 2C7.2096 2 6.45493 2.15283 5.76387 2.43054M3 11.6667C4.33333 13.3333 6 14 8 14C9.65687 14 11.1569 13.3285 12.2427 12.2427M13.9634 7.33332C13.9876 7.55225 14 7.77465 14 7.99999C14 8.79039 13.8472 9.54505 13.5695 10.2361M2.03662 8.66665C2.01242 8.44779 2 8.22532 2 7.99999C2 6.34315 2.67157 4.84315 3.75736 3.75736",
    stroke: "#E00000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 4.51916C10.666 4.51916 12.8532 4.85106 13.1851 4.51914C13.5171 4.18723 13.1851 2 13.1851 2",
    stroke: "#E00000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33268 11.4795C5.33268 11.4795 3.14546 11.1476 2.81354 11.4796C2.48161 11.8114 2.81354 13.9987 2.81354 13.9987",
    stroke: "#E00000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeError);
export default __webpack_public_path__ + "static/media/node_error.f93116650db9cbde4b56b12eaf7bbcb3.svg";
export { ForwardRef as ReactComponent };